import React from 'react';

import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';

import { PERMISSAO_TELA_CONFERENCIAS_FREEZERS_LISTAR } from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';

const SubMenuConferencias = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Conferências"
    icon={<PlaylistAddCheckIcon className={classes.icon} />}
  >
    {permissoes[PERMISSAO_TELA_CONFERENCIAS_FREEZERS_LISTAR] &&
      hasResource('conferencias_temperatura_freezers')}
  </SubMenu>
);

export default SubMenuConferencias;
